import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useAxios from 'axios-hooks';

import FullscreenToggle from '../components/FullscreenToggle';
import { short, time } from '../../common/formatting/date';
import { fullname } from '../../common/formatting/provider';
import { Button } from '../../../../components';
import AddAddendumModal from './AddAddendumModal';

const Addendum = ({ onExpand, onContract, evisitId, userId, showNotification }) => {
	const [isAddModalOpen, setAddModalOpen] = useState(false);
	const [{ data: addendumTypes, loading: addendumTypesLoading, /* error: addendumTypesError */ }] = useAxios('/evisits/view-addendum-types');
	const [{ data: addendums, loading: addendumsLoading, /* error: addendumsError */ }, getAddendums] = useAxios({
		url: `/evisits/${evisitId}/evisit_addendum`,
		params: {
			filter: JSON.stringify({
				include: ['provider']
			})
		}
	});
	const [/* { data, loading, error } */, saveAddendum] = useAxios({
		method: 'POST',
		url: `/evisits/${evisitId}/add-evisit-addendum`
	}, {
		manual: true
	});

	const handleAddAddendum = (data) => {
		saveAddendum({
			params: {
				providerId: userId,
				addendum_type: data.addendumType,
				addendum_text: data.addendum
			}
		}).then(() => {
			setAddModalOpen(false);
			getAddendums();
			showNotification({ status: 'success', message: 'Addendum added successfully' });
		}).catch(() => {
			setAddModalOpen(false);
			showNotification({ message: 'Unable to add addendum. Please try again.', status: 'danger', timeout: 10000 });
		});
	};

	return (
		<div>
			<AddAddendumModal
				isOpen={isAddModalOpen}
				onClose={() => setAddModalOpen(false)}
				addendumTypes={addendumTypes}
				onSave={handleAddAddendum}
			/>
			<FullscreenToggle onExpand={onExpand} onContract={onContract} />
			<div className="pull-right">
				<Button
					primary
					title="Add Addendum"
					onClick={() => setAddModalOpen(true)}
					disabled={addendumTypesLoading}
					className="mr"
				/>
			</div>
			{!addendumsLoading && Array.isArray(addendums) && addendums.map((addendum) => (
				<div key={`addendum-${addendum.id}`}>
					<h4>{addendum.addendum_type} <small>{fullname(addendum.provider)} - {short(addendum.addendum_dttm)} {time(addendum.addendum_dttm)}</small></h4>
					<blockquote>
						<p>{addendum.addendum_text}</p>
					</blockquote>
				</div>
			))}
			{!addendumsLoading && Array.isArray(addendums) && addendums.length === 0 && (
				<div>No records found</div>
			)}
		</div>
	);
};

Addendum.propTypes = {
	onExpand: PropTypes.func.isRequired,
	onContract: PropTypes.func.isRequired,
	evisitId: PropTypes.number.isRequired,
	userId: PropTypes.number.isRequired,
	showNotification: PropTypes.func.isRequired,
};

export default Addendum;
